import { type BookmarksFeaturePriorityListAttributes } from './generated/BookmarksFeaturePriorityListAttributes';
import ApplicationModel, { attr } from '../ApplicationModel';
import { model } from '../modelBuilder';
import Feature from './Feature';
import {
  HasBookmarksPriorityList,
  projectWorkflowScope,
} from './concerns/HasBookmarksPriorityList';
import Epic from './Epic';
import Initiative from './Initiative';
import { type RecordId } from 'javascripts/shared-types';

interface BookmarksFeaturePriorityList
  extends BookmarksFeaturePriorityListAttributes,
    HasBookmarksPriorityList {}

@model
@HasBookmarksPriorityList
class BookmarksFeaturePriorityList extends ApplicationModel {
  // Start auto-generated
  static typename: 'BookmarksFeaturePriorityList' =
    'BookmarksFeaturePriorityList';
  get typename(): 'BookmarksFeaturePriorityList' {
    return 'BookmarksFeaturePriorityList';
  }

  static internalTypename: 'Bookmarks::FeaturePriorityList' =
    'Bookmarks::FeaturePriorityList';
  get internalTypename(): 'Bookmarks::FeaturePriorityList' {
    return 'Bookmarks::FeaturePriorityList';
  }

  static bookmarkName = 'Bookmarks::FeaturePriorityList';

  static inputType = 'PriorityListAttributes!';

  static fields = {
    advancedFilters: attr({ readable: true }),
    advancedFiltersParsed: attr({ readable: true, json: true }),
    clearFilters: attr({ writable: true, readable: false }),
    columnTables: attr({ readable: true, json: true }),
    filters: attr({ readable: true }),
    hasShippableRecords: attr({ readable: true }),
    id: attr({ readable: true }),
    joins: attr({ readable: true, json: true }),
    projectId: attr({ readable: true }),
    totalPrioritizedRecords: attr({ readable: true }),
    totalUnprioritizedRecords: attr({ readable: true }),
    userAllowedToPublishRanks: attr({ readable: true }),
    cardLayout: attr.belongsTo({ readable: true, typename: 'CardLayout' }),
    defaultCardLayout: attr.belongsTo({
      readable: true,
      typename: 'CardLayout',
    }),
    lastPublishedField: attr.belongsTo({
      readable: true,
      typename: 'CustomFieldDefinition',
    }),
    prioritizedRow: attr.belongsTo({ readable: true, typename: 'PivotRow' }),
    prioritizedRows: attr.belongsTo({
      args: { page: 'Int', per: 'Int' },
      readable: true,
      typename: 'PivotRowPage',
    }),
    project: attr.belongsTo({ readable: true, typename: 'Project' }),
    columnWidths: attr.hasMany({ writable: true, readable: true }),
    columns: attr.hasMany({ writable: true, readable: true }),
    lineBreaks: attr.hasMany({ writable: true, readable: true }),
    publishableCustomFields: attr.hasMany({ readable: true }),
    scoringSystemMetrics: attr.hasMany({ readable: true }),
    unprioritizedRecords: attr.hasMany({ readable: true }),
  };
  // End auto-generated

  static get updateFragmentName() {
    return 'updateBookmarksFeaturePriorityList';
  }

  static get bookmarkType() {
    return 'Bookmarks::FeaturePriorityList';
  }

  static get recordType() {
    return Feature;
  }

  get cardView() {
    return this.cardLayout.featureRecordLayout.expanded;
  }

  static async getWorkflowsForProjects(projectIds: RecordId[]) {
    return projectWorkflowScope(
      [Feature, Epic, Initiative].map(model => model.typename)
    )
      .where({ id: projectIds })
      .all();
  }
}

export default BookmarksFeaturePriorityList;
